export enum PaymentGateway {
  PAYTRAIL = 'online-paytrail',
  INVOICE = 'offline',
  VISMA = 'online',
  FREE = 'free',
}
